import { Route } from 'react-router-dom';
import { createLazyRoute } from '../utils/lazyLoading';

// Lazy loaded public components
const CustomerPortalLogin = createLazyRoute(() => import('../CustomerPortalLogin'));
const CustomerPortal = createLazyRoute(() => import('../CustomerPortal'));
const CustomerPortalServiceDetail = createLazyRoute(() => import('../pages/CustomerPortalServiceDetail'));
const ServiceApproval = createLazyRoute(() => import('../ServiceApproval'));
const PaymentSuccess = createLazyRoute(() => import('../PaymentSuccess'));
const PaymentFailure = createLazyRoute(() => import('../PaymentFailure'));
const PaymentCancel = createLazyRoute(() => import('../PaymentCancel'));
const EmailVerification = createLazyRoute(() => import('../EmailVerification'));
const ServiceTrack = createLazyRoute(() => import('../pages/ServiceTrack'));
const PublicQuoteView = createLazyRoute(() => import('../pages/PublicQuoteView'));
const PublicServiceView = createLazyRoute(() => import('../pages/PublicServiceView'));
const PublicWorkOrderView = createLazyRoute(() => import('../pages/PublicWorkOrderView'));

// Legal and information pages
const About = createLazyRoute(() => import('../pages/About'));
const DeliveryReturn = createLazyRoute(() => import('../pages/DeliveryReturn'));
const Privacy = createLazyRoute(() => import('../pages/Privacy'));
const DistanceSelling = createLazyRoute(() => import('../pages/DistanceSelling'));
const GDPR = createLazyRoute(() => import('../pages/GDPR'));
const Pricing = createLazyRoute(() => import('../pages/Pricing'));
const Docs = createLazyRoute(() => import('../pages/Docs'));
const Status = createLazyRoute(() => import('../pages/Status'));
const Features = createLazyRoute(() => import('../pages/Features'));

/**
 * Public Routes Module
 * Handles all public routes (Customer Portal, Payment Results, Subscriptions)
 */
const PublicRoutes = (
    <>
        {/* Customer Portal Routes - Independent of authentication */}
        <Route path="/customer-portal-login" element={<CustomerPortalLogin />} />
        <Route path="/customer-portal" element={<CustomerPortal />} />
        <Route path="/customer-portal/service-detail/:id" element={<CustomerPortalServiceDetail />} />
        <Route path="/service-approval" element={<ServiceApproval />} />

        {/* Service Tracking Route - Public */}
        <Route path="/track/:serviceCode" element={<ServiceTrack />} />

        {/* Public Quote View Route */}
        <Route path="/quote/:token" element={<PublicQuoteView />} />

        {/* Public Service (İş Emri) View Route - personele SMS linki */}
        <Route path="/wo/:token" element={<PublicServiceView />} />

        {/* Public Work Order (çoklu-personel iş emri) View - personele SMS linki */}
        <Route path="/is-emri/:token" element={<PublicWorkOrderView />} />

        {/* Payment Result Routes - Independent of authentication */}
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-failure" element={<PaymentFailure />} />
        <Route path="/payment-cancel" element={<PaymentCancel />} />
        
        {/* Email Verification Route */}
        <Route path="/verify-email/:token" element={<EmailVerification />} />
        
        {/* Legal and Information Pages */}
        <Route path="/about" element={<About />} />
        <Route path="/delivery-return" element={<DeliveryReturn />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/distance-selling" element={<DistanceSelling />} />
        <Route path="/gdpr" element={<GDPR />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/docs" element={<Docs />} />
        <Route path="/status" element={<Status />} />
        <Route path="/features" element={<Features />} />
    </>
);

export default PublicRoutes;
